// Textarea — multi-line input, vertically resizable.

import { forwardRef, type TextareaHTMLAttributes } from 'react';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { error = false, rows = 3, className = '', ...rest },
  ref,
) {
  const classes = ['app-textarea', error && 'app-textarea--error', className]
    .filter(Boolean)
    .join(' ');

  return (
    <textarea
      ref={ref}
      rows={rows}
      className={classes}
      aria-invalid={error || undefined}
      {...rest}
    />
  );
});

export default Textarea;
